module.exports = __webpack_public_path__ + "img/banner_768x2.d01cca3a.jpg";